/**
 * @generated SignedSource<<e92d84c013ca98891c6ec6112986e155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type StreamAutoRecordSetting = "ENABLED_BY_STREAM_AUTOMATION" | "FORCE_DISABLED" | "RESPECT_USER_SETTINGS";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type StreamAutoRecordAutomationConfigMutation$variables = {
  streamID: string;
  value: StreamAutoRecordSetting;
};
export type StreamAutoRecordAutomationConfigMutation$data = {
  readonly updateStreamAutoRecordSettings: {
    readonly stream: {
      readonly autoRecordSetting: {
        readonly __typename: "NoteStreamStreamBasedAutoRecordSource";
        readonly creator: {
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
        } | null;
        readonly value: boolean;
      } | {
        readonly __typename: "NoteStreamUserSettingsBasedAutoRecordEnableSource";
        readonly cannotBeRecordedReason: string | null;
        readonly rules: ReadonlyArray<{
          readonly autoRecordRuleUsers: ReadonlyArray<{
            readonly user: {
              readonly firstName: string;
              readonly fullName: string;
              readonly id: string;
            };
          }>;
          readonly ruleLevel: AutoRecordRuleLevel;
        }>;
        readonly users: ReadonlyArray<{
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
        }>;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly automationConfigurations: ReadonlyArray<{
        readonly automation: {
          readonly codeName: string;
        };
        readonly id: string;
        readonly isActive: boolean;
        readonly stream: {
          readonly hasAnyAutomationActive: boolean;
          readonly id: string;
        };
        readonly tasks: ReadonlyArray<{
          readonly __typename: string;
          readonly data?: {
            readonly addBanner: boolean;
            readonly allParticipants: boolean;
            readonly channelId: string;
            readonly channelName: string;
            readonly conversation: string;
            readonly conversationName: string;
            readonly emails?: ReadonlyArray<string>;
            readonly includeAiSummary: boolean;
            readonly isUser: boolean;
            readonly message: string;
            readonly notificationPath: string;
            readonly sendNotificationTo: string;
            readonly slackTeamId: string | null;
            readonly team: string;
            readonly teamName: string;
            readonly type: string;
            readonly userIds?: ReadonlyArray<string>;
            readonly zoomChannelId: string;
            readonly zoomChannelName: string;
          };
          readonly delta: number;
          readonly id: string;
        }>;
      }> | null;
      readonly claimedEvents: ReadonlyArray<{
        readonly willBeRecorded: WillBeRecordedType;
      }>;
      readonly id: string;
      readonly meetingRecapAutoShareSource: {
        readonly __typename: "UserMeetingRecapAutoShareSettings";
        readonly id: string;
        readonly sendTo_U: UserMeetingRecapSendTo;
        readonly user: {
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly schedulingMeetingAssistantAutomationIsActive: boolean;
    };
  } | null;
};
export type StreamAutoRecordAutomationConfigMutation = {
  response: StreamAutoRecordAutomationConfigMutation$data;
  variables: StreamAutoRecordAutomationConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v2 = [
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamID"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "type": "NoteStreamStreamBasedAutoRecordSource",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "users",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ruleLevel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "AutoRecordRuleUser",
  "kind": "LinkedField",
  "name": "autoRecordRuleUsers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cannotBeRecordedReason",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": "sendTo_U",
      "args": null,
      "kind": "ScalarField",
      "name": "sendTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v6/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UserMeetingRecapAutoShareSettings",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedulingMeetingAssistantAutomationIsActive",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "codeName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAnyAutomationActive",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNotificationTo",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationPath",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allParticipants",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackTeamId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversation",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversationName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUser",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoomChannelName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "includeAiSummary",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "tasks",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delta",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "addBanner",
              "storageKey": null
            },
            (v19/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSaverCancellation",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v19/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSaverCancellationAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userIds",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "EmailReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomReminder",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v31/*: any*/),
            (v32/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomReminderAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emails",
              "storageKey": null
            },
            (v33/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "EmailRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SlackRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/),
            (v33/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "SlackRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            (v30/*: any*/),
            (v33/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MSTeamsRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZoomRecap",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v20/*: any*/),
            (v21/*: any*/),
            (v31/*: any*/),
            (v32/*: any*/),
            (v33/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ZoomRecapAutomationTask",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PromptNotification",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "PromptNotificationAutomationTask",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamAutoRecordAutomationConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateStreamAutoRecordSettings",
        "kind": "LinkedField",
        "name": "updateStreamAutoRecordSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autoRecordSetting",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoRecordRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingRecapAutoShareSource",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "claimedEvents",
                "plural": true,
                "selections": [
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StreamAutoRecordAutomationConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateStreamAutoRecordSettings",
        "kind": "LinkedField",
        "name": "updateStreamAutoRecordSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autoRecordSetting",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutoRecordRule",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meetingRecapAutoShareSource",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationConfigurationNode",
                "kind": "LinkedField",
                "name": "automationConfigurations",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationNode",
                    "kind": "LinkedField",
                    "name": "automation",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v34/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "claimedEvents",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9390f67aa4fc765fbc1cfff7b763b5b9",
    "id": null,
    "metadata": {},
    "name": "StreamAutoRecordAutomationConfigMutation",
    "operationKind": "mutation",
    "text": "mutation StreamAutoRecordAutomationConfigMutation(\n  $value: StreamAutoRecordSetting!\n  $streamID: ID!\n) {\n  updateStreamAutoRecordSettings(streamId: $streamID, value: $value) {\n    stream {\n      id\n      autoRecordSetting {\n        __typename\n        ... on NoteStreamStreamBasedAutoRecordSource {\n          value\n          creator {\n            id\n            firstName\n            fullName\n          }\n        }\n        ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n          users {\n            id\n            firstName\n            fullName\n          }\n          rules {\n            ruleLevel\n            autoRecordRuleUsers {\n              user {\n                id\n                firstName\n                fullName\n              }\n            }\n            id\n          }\n          cannotBeRecordedReason\n        }\n      }\n      meetingRecapAutoShareSource {\n        __typename\n        ... on UserMeetingRecapAutoShareSettings {\n          id\n          sendTo_U: sendTo\n          user {\n            id\n            fullName\n            firstName\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      schedulingMeetingAssistantAutomationIsActive\n      automationConfigurations {\n        id\n        isActive\n        automation {\n          codeName\n          id\n        }\n        stream {\n          id\n          hasAnyAutomationActive\n        }\n        tasks {\n          __typename\n          id\n          delta\n          ... on TimeSaverReminderAutomationTask {\n            data {\n              type\n              addBanner\n              sendNotificationTo\n            }\n          }\n          ... on TimeSaverCancellationAutomationTask {\n            data {\n              type\n              sendNotificationTo\n            }\n          }\n          ... on EmailReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              userIds\n            }\n          }\n          ... on SlackReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n            }\n          }\n          ... on MSTeamsReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n            }\n          }\n          ... on ZoomReminderAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n            }\n          }\n          ... on EmailRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              allParticipants\n              emails\n              includeAiSummary\n            }\n          }\n          ... on SlackRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              slackTeamId\n              channelId\n              channelName\n              includeAiSummary\n            }\n          }\n          ... on MSTeamsRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              team\n              teamName\n              conversation\n              conversationName\n              isUser\n              includeAiSummary\n            }\n          }\n          ... on ZoomRecapAutomationTask {\n            data {\n              notificationPath\n              message\n              zoomChannelId\n              zoomChannelName\n              includeAiSummary\n            }\n          }\n          ... on PromptNotificationAutomationTask {\n            data {\n              message\n            }\n          }\n        }\n      }\n      claimedEvents {\n        willBeRecorded\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "badb67de17a6ad39bd09d4fb80b8da3d";

export default node;
